<template>
	<v-form @keydown.enter.prevent>
		<v-container v-if="isEdit">
			<v-layout row wrap>
				<v-flex xs12 md6>
					<v-text-field ref="defaultFocusElement" v-model.trim="value.firstName">
						<template slot="label">Emergency Contact's First Name</template>
					</v-text-field>
				</v-flex>
				<v-flex xs12 md6>
					<v-text-field v-model.trim="value.lastName">
						<template slot="label">Emergency Contact's Last Name</template>
					</v-text-field>
				</v-flex>
				<v-flex xs12 md6>
					<v-select v-model="value.relation" :items="relations">
						<template slot="label">Emergency Contact's Relation</template>
					</v-select>
				</v-flex>
				<v-flex xs12 md6>
					<v-text-field v-model.trim="value.phoneNo" label="Phone No">
						<template slot="label">Emergency Contact's Phone No</template>
					</v-text-field>
				</v-flex>
				<v-flex xs12 md6>
					<v-text-field v-model.trim="value.email" :error-messages="emailErrors">
						<template slot="label">Emergency Contact's Email</template>
					</v-text-field>
				</v-flex>
			</v-layout>
		</v-container>
		<v-container v-else>
			<v-layout row wrap>
				<v-flex xs12 md6>
					<div class="form-group">
						<span class="form-label">Emergency Contact's First Name</span>
						<span class="form-value">{{ $_getFormValue('firstName') }}</span>
					</div>
				</v-flex>
				<v-flex xs12 md6>
					<div class="form-group">
						<span class="form-label">Emergency Contact's Last Name</span>
						<span class="form-value">{{ $_getFormValue('lastName') }}</span>
					</div>
				</v-flex>
				<v-flex xs12 md6>
					<div class="form-group">
						<span class="form-label">Emergency Contact's Relation</span>
						<span class="form-value">{{ $_getFormValue('relation') }}</span>
					</div>
				</v-flex>
				<v-flex xs12 md6>
					<div class="form-group">
						<span class="form-label">Emergency Contact's Phone No</span>
						<span class="form-value">{{ $_getFormValue('phoneNo') }}</span>
					</div>
				</v-flex>
				<v-flex xs12 md6>
					<div class="form-group">
						<span class="form-label">Emergency Contact's Email</span>
						<span class="form-value">{{ $_getFormValue('email') }}</span>
					</div>
				</v-flex>
			</v-layout>
		</v-container>
	</v-form>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { email } from 'vuelidate/lib/validators';
	import formMixin from '@/mixins/employeeFormMixin';

	export default {
		mixins: [validationMixin, formMixin],
		validations: {
			value: {
				firstName: {},
				lastName: {},
				email: {
					email
				},
				phoneNo: {},
				relation: {}
			}
		},
		computed: {
			emailErrors() {
				const errors = [];
				if (!this.$v.value.email.$dirty) return errors;
				!this.$v.value.email.email && errors.push('Must be valid e-mail');
				return errors;
			},
			relations() {
				return ['Wife', 'Husband', 'Spouse', 'Brother', 'Sister', 'Next of Kin', 'Son', 'Daughter', 'Partner', 'Mother', 'Father', 'Other'];
			}
		}
	};
</script>
